import React from 'react';
import TextInput from '../UI/TextInput';

const ChangeUsernameModalContent = ({ register, errors }) => {
  return (
    <>
      <h5 className="mb-4">New Username</h5>
      <TextInput 
        name="username" 
        register={register({ required: true })}
        placeholder="Username"
      />
      {errors.password && errors.password.type === "required" &&
        <p className="warnMessage">This field is required</p>
      }
    </>
  )
}

export default ChangeUsernameModalContent;